import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";

export default function AdminActivity() {
  const [logs, setLogs] = useState(null);
  const load = () => api.get("/admin/activity?limit=200").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  useEffect(() => { load(); }, []);

  const del = (id) => api.delete(`/admin/activity/${id}`).then(() => { toast.success("Entry deleted"); load(); });
  const clearAll = () => {
    if (!window.confirm("Clear the entire activity log? This cannot be undone.")) return;
    api.delete("/admin/activity").then(() => { toast.success("Activity log cleared"); load(); });
  };

  if (!logs) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-forest" /></div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <h1 className="font-heading text-3xl lg:text-4xl text-forest tracking-tight">Activity Log</h1>
        {logs.length > 0 && <Button variant="outline" onClick={clearAll} data-testid="activity-clear-all" className="rounded-full border-terracotta text-terracotta hover:bg-terracotta hover:text-white"><Trash2 className="w-4 h-4 mr-1.5" /> Clear All</Button>}
      </div>
      {logs.length === 0 ? (
        <div className="bg-white rounded-2xl soft-shadow p-10 text-center text-brown/60">No admin activity recorded yet.</div>
      ) : (
        <div className="bg-white rounded-2xl soft-shadow overflow-hidden" data-testid="activity-table">
          <table className="w-full text-sm">
            <thead className="bg-sand text-olive">
              <tr>
                <th className="text-left px-4 py-3 font-500">Admin</th>
                <th className="text-left px-4 py-3 font-500">Action</th>
                <th className="text-left px-4 py-3 font-500 hidden sm:table-cell">Detail</th>
                <th className="text-left px-4 py-3 font-500">When</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-sand" data-testid={`activity-row-${l.id}`}>
                  <td className="px-4 py-3 text-ink">{l.user_name}</td>
                  <td className="px-4 py-3 text-forest font-500">{l.action}</td>
                  <td className="px-4 py-3 text-brown/70 hidden sm:table-cell max-w-[280px] truncate">{l.detail}</td>
                  <td className="px-4 py-3 text-brown/60 whitespace-nowrap">{new Date(l.at).toLocaleString()}</td>
                  <td className="px-4 py-3 text-right"><button onClick={() => del(l.id)} data-testid={`activity-delete-${l.id}`} className="p-1.5 hover:bg-sand rounded-lg" title="Delete"><Trash2 className="w-4 h-4 text-terracotta" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
